import { render, staticRenderFns } from "./getOverView.vue?vue&type=template&id=44a3ff7a&scoped=true&"
import script from "./getOverView.vue?vue&type=script&lang=js&"
export * from "./getOverView.vue?vue&type=script&lang=js&"
import style0 from "./getOverView.vue?vue&type=style&index=0&id=44a3ff7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3ff7a",
  null
  
)

export default component.exports